import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";
export function useUserData(){
    return useQuery({
        ...queryKeys.user.data,
    })
}